import { axiosInstance } from "./axiosInstance";
import appConfig from "configs/app.config";

let URL = `${appConfig.baseUrl}auth`;

export async function apiGetModulePermission() {
  return axiosInstance.get(`${URL}/get_module_with_permission`);
}
export async function apiSaveModulePermission(data) {
  return axiosInstance.post(`${URL}/save_role`, data);
}
export async function apiEditModulePermission(data) {
  return axiosInstance.post(`${URL}/edit_role`, data);
}
export async function apiDeleteRole(data) {
  return axiosInstance.post(`${URL}/delete_role`, data);
}

export async function apiGetRoles() {
  return axiosInstance.get(`${URL}/get_role_list_detail`);
}

export async function apiGetRolesById(id) {
  return axiosInstance.get(`${URL}/get_role_list_detail?role_id=${id}`);
}

export async function apiDashboardMenus(id) {
  return axiosInstance.get(`${URL}/get_menu?user_id=${id}`);
}
